module.exports = __webpack_public_path__ + "static-prod-1/media/pc_bg.a8b5cf35.mp4";